<!-- =========================================================================================
    File Name: ListRetailers.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div class="flex flex-wrap items-center">
      <div class="flex-grow">
        <vs-dropdown class="cursor-pointer" vs-trigger-click>
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">
                {{currentPage * paginationPageSize - (paginationPageSize - 1)}} -
                {{progressData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : progressData.length}} of {{ totalprogresss }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>

            <vs-dropdown-item @click="gridApi.paginationSetPageSize(20); loadProductBuffer();">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(50); loadProductBuffer();">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(100); loadProductBuffer();">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(150); loadProductBuffer();">
              <span>150</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>


      </div>

      <v-select placeholder="Select Progress Type" class="mr-4 " style="min-width: 200px" :options="names" v-model="selectedname"/>
    </div>


    <!-- AgGrid Table -->
    <ag-grid-vue
      :animateRows="true"
      :columnDefs="columnDefs"
      :components="components"
      :defaultColDef="defaultColDef"
      :enableRtl="$vs.rtl"
      :floatingFilter="true"
      :gridOptions="gridOptions"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :rowData="progressData"
      :suppressPaginationPanel="true"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      colResizeDefault="shift"
      ref="agGridTable">
    </ag-grid-vue>

    <vs-pagination :total="totalPages" v-model="currentPage"/>

  </div>


</template>

<script>
import TableSimulation from './components/TableSimulation.vue'
import TableDate from './components/TableDate.vue'
import TableScore from './components/TableScore'
import TableDuration from './components/TableDuration'
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'


export default {
  components: {
    AgGridVue,
    vSelect,
    TableSimulation,
    TableDate,
    TableScore,
    TableDuration
  },
  data () {
    return {

      progressData: [],
      totalprogresss: 0,

      searchQuery: '',
      selectedname: {id: 'submissions', label: 'Submissions'},

      names: [
        {id: 'started', label: 'Started'},
        {id: 'submissions', label: 'Submissions'},
        {id: 'completed', label: 'Completed'}
      ],

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        valueFormatter: (params) => {
          if (typeof params.value === 'string') {
            const value = params.value
            return value.charAt(0).toUpperCase() + value.slice(1)
          }

          return params
        }
      },
      columnDefs: [{}],

      // Cell Renderer Components
      components: {
        TableSimulation,
        TableDate,
        TableScore,
        TableDuration
      },
      totalPages: 0
    }
  },
  watch: {
    'selectedname' () {
      this.changeTableType()
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
        this.loadProductBuffer(val)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    changeTableType (val) {
      if (this.selectedname.id === 'started') {
        this.columnDefs = [
          {
            headerName: 'Simulation',
            field: 'simulation_id',
            filter: true,
            cellRendererFramework: 'TableSimulation'
          },
          {
            headerName: 'Duration',
            field: 'duration',
            filter: true,
            cellRendererFramework: 'TableDuration'
          },
          {
            headerName: 'Time',
            field: 'created_at',
            filter: true,
            cellRendererFramework: 'TableDate'
          }
        ]
      }

      if (this.selectedname.id === 'submissions') {
        this.columnDefs = [
          {
            headerName: 'Simulation',
            field: 'simulation_id',
            filter: true,
            cellRendererFramework: 'TableSimulation'
          },
          {
            headerName: 'Score',
            field: 'score',
            filter: true,
            cellRendererFramework: 'TableScore'
          },
          {
            headerName: 'Time',
            field: 'created_at',
            filter: true,
            cellRendererFramework: 'TableDate'
          }
        ]
      }

      if (this.selectedname.id === 'completed') {
        this.columnDefs = [
          {
            headerName: 'Simulation',
            field: 'simulation_id',
            filter: true,
            cellRendererFramework: 'TableSimulation'
          },
          {
            headerName: 'Time',
            field: 'created_at',
            filter: true,
            cellRendererFramework: 'TableDate'
          }
        ]
      }

      this.loadProductBuffer(val)

    },
    loadProductBuffer (page = 0) {

      if (page === 0) {
        page = this.currentPage
      }


      this.$http.get(`progress/raw/count?amount=${this.paginationPageSize}&type=${this.selectedname.id}&course=${this.course.id}&user=${this.user_id}`)
        .then(response => {

          if (response.data.data) {

            const data = response.data.data

            if (data.pages) {
              this.totalPages = data.pages
              this.totalprogresss = data.total
            }

          }
        })
        .catch(() => {

        })

      this.$http.get(`progress/raw?amount=${this.paginationPageSize}&page=${page}&type=${this.selectedname.id}&course=${this.course.id}&user=${this.user_id}`)
        .then(response => {

          if (response.data.data) {
            this.progressData = response.data.data
          }

          this.gridApi.sizeColumnsToFit()
        })
        .catch(exception => {

          let error = 'An unknown error occurred while loading the progress list'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to load progress list',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  props: {
    course: {
      type: Object,
      required: true
    },
    user_id: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    this.changeTableType()

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
  }
}

</script>

<style lang="scss">

</style>
